import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

const mainComic = featuredComics[0];
const sideComics = [featuredComics[1], featuredComics[2]];
const bottomComics = [featuredComics[3], featuredComics[4], featuredComics[5]];

export default function FeaturedSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 comic-dot-pattern" aria-labelledby="featured-title">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-comic-accent text-xs font-medium tracking-widest mb-3">HOT PICKS</p>
            <h2 id="featured-title" className="text-3xl md:text-5xl font-black text-white">
              本周<span className="text-comic-primary">热播</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm hidden md:block">精选优质韩漫 · 品质保证</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 mb-6">
          {/* 左侧大卡片 */}
          <Link to={`/comic/${mainComic.id}`} className="md:col-span-5 group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden h-full transition-all duration-300 hover:bg-comic-card-hover">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20dramatic%20scene%20with%20handsome%20bodyguard%20and%20beautiful%20goddess%20character%2C%20warm%20coral%20and%20rose%20pink%20accents%2C%20clean%20composition%20with%20simple%20dark%20background%2C%20professional%20webtoon%20quality&width=800&height=600&seq=comic-goddess-bodyguard-feat&orientation=landscape"
                  alt={mainComic.title}
                  title={`${mainComic.title} - 韩国漫画网热门推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-accent text-white">
                    {mainComic.status}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-comic-secondary text-xs"></i>
                  <span className="text-white text-xs font-bold">{mainComic.rating}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-white text-xl font-bold mb-1 group-hover:text-comic-primary transition-colors">
                  {mainComic.title}
                </h3>
                <p className="text-gray-400 text-sm mb-2">{mainComic.author} · {mainComic.latestChapter}</p>
                <p className="text-gray-500 text-xs line-clamp-2">{mainComic.description}</p>
              </div>
            </article>
          </Link>

          {/* 右侧两列 */}
          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* 第一张侧卡 */}
            <Link to={`/comic/${sideComics[0].id}`} className="group cursor-pointer">
              <article className="bg-comic-card rounded-2xl overflow-hidden h-full transition-all duration-300 hover:bg-comic-card-hover">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20illustration%2C%20powerful%20cultivator%20in%20urban%20setting%2C%20dramatic%20lighting%20with%20warm%20coral%20and%20rose%20pink%20highlights%2C%20clean%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20quality&width=600&height=800&seq=comic-urban-cultivation-side&orientation=portrait"
                    alt={sideComics[0].title}
                    title={`${sideComics[0].title} - 韩国漫画网热门推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-accent text-white">
                      {sideComics[0].status}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-2.5 py-1">
                    <i className="ri-star-fill text-comic-secondary text-xs"></i>
                    <span className="text-white text-xs font-bold">{sideComics[0].rating}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                    <h3 className="text-white font-bold text-sm mb-0.5">{sideComics[0].title}</h3>
                    <p className="text-gray-300 text-xs">{sideComics[0].author}</p>
                  </div>
                </div>
              </article>
            </Link>

            {/* 第二张侧卡 */}
            <Link to={`/comic/${sideComics[1].id}`} className="group cursor-pointer">
              <article className="bg-comic-card rounded-2xl overflow-hidden h-full transition-all duration-300 hover:bg-comic-card-hover">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20character%20illustration%2C%20powerful%20hunter%20with%20dark%20aura%2C%20dramatic%20lighting%20with%20warm%20coral%20and%20rose%20pink%20highlights%2C%20clean%20simple%20dark%20background%2C%20professional%20webtoon%20cover%20quality&width=600&height=800&seq=comic-solo-leveling-side&orientation=portrait"
                    alt={sideComics[1].title}
                    title={`${sideComics[1].title} - 韩国漫画网热门推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-comic-cyan text-black">
                      {sideComics[1].status}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-2.5 py-1">
                    <i className="ri-star-fill text-comic-secondary text-xs"></i>
                    <span className="text-white text-xs font-bold">{sideComics[1].rating}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                    <h3 className="text-white font-bold text-sm mb-0.5">{sideComics[1].title}</h3>
                    <p className="text-gray-300 text-xs">{sideComics[1].author}</p>
                  </div>
                </div>
              </article>
            </Link>
          </div>
        </div>

        {/* 第二行三列 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          {/* 卡片4: 公爵的契约未婚妻 */}
          <Link to={`/comic/${bottomComics[0].id}`} className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover">
              <div className="flex">
                <div className="w-28 h-36 flex-shrink-0 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20elegant%20duke%20and%20heroine%20romance%20illustration%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-duke-fiancee-small&orientation=portrait"
                    alt={bottomComics[0].title}
                    title={`${bottomComics[0].title} - 韩国漫画网推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between">
                  <div>
                    <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                      {bottomComics[0].title}
                    </h3>
                    <p className="text-gray-400 text-xs mb-1">{bottomComics[0].author}</p>
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 rounded-full text-xs bg-comic-accent/20 text-comic-accent">
                        {bottomComics[0].status}
                      </span>
                      <span className="text-gray-500 text-xs flex items-center gap-0.5">
                        <i className="ri-star-fill text-comic-secondary text-xs"></i>
                        {bottomComics[0].rating}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-500 text-xs line-clamp-1 mt-1">{bottomComics[0].latestChapter}</p>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片5: 地下城重置 */}
          <Link to={`/comic/${bottomComics[1].id}`} className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover">
              <div className="flex">
                <div className="w-28 h-36 flex-shrink-0 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20dungeon%20adventure%20character%20portrait%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-dungeon-reset-small&orientation=portrait"
                    alt={bottomComics[1].title}
                    title={`${bottomComics[1].title} - 韩国漫画网推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between">
                  <div>
                    <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                      {bottomComics[1].title}
                    </h3>
                    <p className="text-gray-400 text-xs mb-1">{bottomComics[1].author}</p>
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 rounded-full text-xs bg-comic-accent/20 text-comic-accent">
                        {bottomComics[1].status}
                      </span>
                      <span className="text-gray-500 text-xs flex items-center gap-0.5">
                        <i className="ri-star-fill text-comic-secondary text-xs"></i>
                        {bottomComics[1].rating}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-500 text-xs line-clamp-1 mt-1">{bottomComics[1].latestChapter}</p>
                </div>
              </div>
            </article>
          </Link>

          {/* 卡片6: 魔王学院的不适格者 */}
          <Link to={`/comic/${bottomComics[2].id}`} className="group cursor-pointer">
            <article className="bg-comic-card rounded-2xl overflow-hidden transition-all duration-300 hover:bg-comic-card-hover">
              <div className="flex">
                <div className="w-28 h-36 flex-shrink-0 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20thumbnail%20style%2C%20demon%20lord%20character%20portrait%2C%20warm%20coral%20and%20rose%20pink%20color%20scheme%2C%20clean%20dark%20background%2C%20webtoon%20cover%20thumbnail%20quality&width=300&height=400&seq=comic-demon-lord-small&orientation=portrait"
                    alt={bottomComics[2].title}
                    title={`${bottomComics[2].title} - 韩国漫画网推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between">
                  <div>
                    <h3 className="text-white font-bold text-sm mb-1 group-hover:text-comic-primary transition-colors">
                      {bottomComics[2].title}
                    </h3>
                    <p className="text-gray-400 text-xs mb-1">{bottomComics[2].author}</p>
                    <div className="flex items-center gap-2">
                      <span className="px-2 py-0.5 rounded-full text-xs bg-comic-cyan/20 text-comic-cyan">
                        {bottomComics[2].status}
                      </span>
                      <span className="text-gray-500 text-xs flex items-center gap-0.5">
                        <i className="ri-star-fill text-comic-secondary text-xs"></i>
                        {bottomComics[2].rating}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-500 text-xs line-clamp-1 mt-1">{bottomComics[2].latestChapter}</p>
                </div>
              </div>
            </article>
          </Link>
        </div>
      </div>
    </section>
  );
}